import { returnStatuses } from '@reveni-io/reveni-ui'

import { userPermissions } from '@/common/constants'

export const allTransactionsHasAvailableStatusToAcceptOrReject = (transactions, selectedTransactionIds) => {
  const acceptedStatuses = [
    returnStatuses.inProgress,
    returnStatuses.shipped,
    returnStatuses.received,
    returnStatuses.forReview,
  ]

  const selectedTransactions = transactions.filter(transaction => selectedTransactionIds.includes(transaction.id))

  return selectedTransactions.every(transaction => acceptedStatuses.includes(transaction.status))
}

export const hasJustOnHoldTransactions = ({ orders, selectedOrders, hasPermission }) => {
  const selectedTransactions = orders.filter(transaction => selectedOrders.includes(transaction.id))

  return (
    hasPermission(userPermissions.editReturnStatus) &&
    selectedTransactions.every(transaction => transaction.status === returnStatuses.onHold) &&
    selectedTransactions.length > 0
  )
}

export const canTransactionsBeAcceptedOrRejected = ({ orders, selectedOrders, hasPermission }) => {
  return (
    allTransactionsHasAvailableStatusToAcceptOrReject(orders, selectedOrders) &&
    hasPermission(userPermissions.editReturnStatus) &&
    selectedOrders?.length > 0
  )
}

export const shouldShowNoAvailableActionsLabel = ({
  orders,
  selectedOrders,
  selectableTransactionsCount,
  hasPermission,
}) => {
  return (
    !selectableTransactionsCount ||
    (!canTransactionsBeAcceptedOrRejected({ orders, selectedOrders, hasPermission }) &&
      !hasJustOnHoldTransactions({ orders, selectedOrders, hasPermission }) &&
      selectedOrders?.length > 0)
  )
}
